/* eslint-disable max-lines */
import React, { useEffect } from 'react';

// navigation
import { useNavigate } from 'react-router-dom';
import ForgotPasswordLink from './ForgotPasswordLink';
import { useEmailPagePath } from '../../../navigation';

// context, state and remote data
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown';

// view components
import CardLayout from './../CardLayout';
import PasswordImage from './Images/Password.svg';
import PasswordInput from 'src/viewLayer/components/shared/Inputs/PasswordInput';
import TrackableButton from '../../shared/TrackableButton';
import BackButton from '../BackButton';
import ChangeEmailLink from 'src/viewLayer/components/shared/HintLinks/ChangeEmailLink';
import {
  ActionsContainer,
  FormContainer,
  InputFrame,
  LoginPasswordPageContainer
} from './index.styled';

import { t } from 'src/viewLayer/helpers/translations';

export default function LoginPasswordPage({
  appType,
  captchaFeature,
  email,
  errorKey,
  isFocused,
  inProgress,
  path,
  onChange,
  onSubmit,
  password
}) {
  const navigate = useNavigate();
  const emailPagePath = useEmailPagePath();
  useTrackPageShown({ appType, pageType: path });
  useEffect(() => {
    if (!email) navigate(emailPagePath, { replace: true });
  }, [email, emailPagePath, navigate]);

  const handleOnSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if(password.length > 0 && !inProgress){
      onSubmit();
    }
  }

  return (
    <LoginPasswordPageContainer>
      <CardLayout
        email={email}
        isPasswordPage
        title={ t('password.title') }
        subtitle={ email }
        Image={ PasswordImage }>
        <ChangeEmailLink />
        <BackButton trackingId="backbutton-password-to-email" path={ path }/>
        <FormContainer>
          <form onSubmit={ handleOnSubmit }>
            <InputFrame>
              <PasswordInput
                errorKey={ errorKey }
                isFocused={ isFocused }
                onChangeHandler={ onChange }
                value={ password }
                disabled={ inProgress } />
            </InputFrame>
          </form>
          <ForgotPasswordLink email={email} />
          { captchaFeature }
          <ActionsContainer>
            <TrackableButton
              id="uat-continue-button"
              disabled={ password.length === 0 || inProgress }
              inProgress={ inProgress }
              onClick={ handleOnSubmit }
              title="Login button"
              trackingId="password_submit">
              { t('password.button.login') }
            </TrackableButton>
          </ActionsContainer>
        </FormContainer>
      </CardLayout>
    </LoginPasswordPageContainer>
  );
};
